
























import Vue from 'vue';

export default Vue.component('custom-month-picker', {
  name: 'CustomMonthPicker',
  props: {
    'current-date': {
      type: Date
    },
  },
  data () {
    return {
      months: [] as any[],
      monthYearLabel: "July 2018",
      fadeMonthYearLabel: false,
      monthNameShorthand: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      monthsStyle: {transform: "translateX(-936px)"},
      selectedMonth: {} as any,
      currentLeft: 0
    }
  },
  created: function () {
    this.initializeMonths();
    this.monthYearLabel = this.monthNames[(this as any).currentDate.getUTCMonth()] + " " + (this as any).currentDate.getUTCFullYear();
  },
  mounted: function () {
    let self = this;
    setTimeout(function () {
      self.selectMonthByDate((self as any).currentDate);
    },0);
  },
  methods: {
    selectMonth (month: any, event: any = undefined, monthIndex: number | undefined = undefined, fadeMonthYearLabel: boolean = true, broadcastChange: boolean = true) {
      this.months.forEach(function (currentMonth: any) {
        currentMonth.isSelected = false;
      });
      month.isSelected = true;
      if (broadcastChange) {
        const dateString = month.yearNumber + "-" + (("0"+(month.monthNumber+1)).slice(-2)) + "-01";
        this.$emit('monthChange', new Date(dateString));
      }
      let self = this as any;
      self.fadeMonthYearLabel = fadeMonthYearLabel;
      let offsetLeft;
      let elementWidthAdjust;
      if (event && event.target) {
        offsetLeft = event.target.offsetLeft;
        elementWidthAdjust = event.target.offsetWidth ;
      } else if ((monthIndex || monthIndex === 0) && (this.$refs as any).month[monthIndex]) {
        offsetLeft = (this.$refs as any).month[monthIndex].offsetLeft;
        elementWidthAdjust = (this.$refs as any).month[monthIndex].offsetWidth ;
      }
      let midPoint = (self.$refs as any).monthPicker ? (self.$refs as any).monthPicker.offsetWidth / 2 : 0;
      this.currentLeft = ((offsetLeft - midPoint + elementWidthAdjust) * -1);
      self.monthsStyle = {transform: "translateX(" + this.currentLeft + "px)"};
      setTimeout(function () {
        self.monthYearLabel = self.monthNames[month.monthNumber] + " " + month.yearNumber;
	      self.fadeMonthYearLabel = false;
      },400);
      setTimeout(function () {
        if (self.selectedMonth.yearNumber) {
          if (month.yearNumber > self.selectedMonth.yearNumber) {
            self.shiftMonths();
          } else if (month.yearNumber < self.selectedMonth.yearNumber) {
            self.shiftMonths(true);
          }
        }
        self.selectedMonth = month;
      },400);
    },
    selectMonthByDate (date: Date, fadeMonthYearLabel: boolean = false) {
      let monthNumber = date.getUTCMonth(); 
      let yearNumber = date.getUTCFullYear(); 
      let currentMonth;
      for (let i=0,leni=this.months.length; i<leni; i++) {
        currentMonth = this.months[i];
        if (currentMonth.yearNumber === yearNumber && currentMonth.monthNumber === monthNumber) {
          this.selectMonth(currentMonth, null, i, fadeMonthYearLabel, false);
        }
      }
    },
    initializeMonths () {
      let tempMonths = [] as any[];
      tempMonths = tempMonths.concat( this.buildYear((this as any).currentDate.getUTCFullYear() - 2) );
      tempMonths = tempMonths.concat( this.buildYear((this as any).currentDate.getUTCFullYear() - 1) );
      tempMonths = tempMonths.concat( this.buildYear((this as any).currentDate.getUTCFullYear()) );
      tempMonths = tempMonths.concat( this.buildYear((this as any).currentDate.getUTCFullYear() + 1) );
      tempMonths = tempMonths.concat( this.buildYear((this as any).currentDate.getUTCFullYear() + 2) );
      this.months = tempMonths;
    },
    shiftMonths (backward: boolean = false) {
      let tempMonths = [] as any[];
      let self = this as any;
      if (backward) {
        tempMonths = this.buildYear(this.months[0].yearNumber - 1);
        tempMonths = tempMonths.concat( this.months );
      } else {
        tempMonths = tempMonths.concat(this.months);
        tempMonths = this.removeYear(tempMonths, true);
      }
      self.months = tempMonths;
      let monthsWidthDifferece = backward ? -468 + 15 : 468 - 15;
      let newTranslation = self.currentLeft + monthsWidthDifferece;
      self.monthsStyle = {transform: "translateX(" + newTranslation + "px)", transition: "none"};
      if (backward) {
        tempMonths = self.removeYear(tempMonths);
      } else {
        tempMonths = tempMonths.concat(self.buildYear(tempMonths[tempMonths.length - 1].yearNumber + 1));
      } 
      self.months = tempMonths;          
    },
    buildYear (year: any) {
      let tempYear = [];
      for (let i=0,leni=12; i<leni; i++) {
        tempYear.push({ name: this.monthNameShorthand[i], monthNumber: i, yearNumber: year });
      }
      return tempYear;
    },
    removeYear (monthsArray: Array<any>, past: boolean = false) {
      return past ? monthsArray.slice(12) : monthsArray.slice(0,-12);
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/calendarShifts/calendarShiftsComponents/CustomMonthPicker.vue